import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import { PreparationReportsDetailsByPartner } from "./components/PreparationReportsDetailsByPartner";

export function PreparationReportsDetailsByPartnerPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <PreparationReportsDetailsByPartner />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
